import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/auth";
//LAYOUT COMPONENTS
import Menu from "../comun/Menu/Menu";
import Footer from "../Footer";
import Item from "../comun/Menu/Item";
import ClasificadorBienes from "./Actualizacion/ClasificadorBienes/ClasificadorBienes";
import CatalogoActivos from "./Actualizacion/CatalogoActivos/CatalogoActivos";
import UbicacionesBienes from "./Actualizacion/UbicacionBienes/UbicacionesBienes";
import MotivosIncorporacion from "./Actualizacion/MotivosIncorporacion/MotivosIncorporacion";
import IncorporacionBienesMuebles from "./Actualizacion/IncorporacionBienesMuebles/IncorporacionBienesMuebles";
import MotivosDesincorporacion from "./Actualizacion/MotivosDesincorporacion/MotivosDesincorporacion";
import IncorporacionBienesInmuebles from "./Actualizacion/IncorporacionBienesInmuebles/IncorporacionBienesInmuebles";
import DesincorporacionBienesMuebles from "./Actualizacion/DesincorporacionBienesMuebles/DesincorporacionBienesMuebles";
import DesincorporacionBienesInmuebles from "./Actualizacion/DesincorporacionBienesInmuebles/DesincorporacionBienesInmuebles";
import TransferenciaBienes from "./Actualizacion/TransferenciaBienes/TransferenciaBienes";
import ListadosIncorporacionesBienes from "./Imprimir/ListadoIncorporacionesBienesMuebles/ListadoIncorporacionesBienesMuebles";
import ListadosIncorporacionesBienesInmuebles from "./Imprimir/ListadosIncorporacionesBienesInmuebles/ListadosIncorporacionesBienesInmuebles";
import ListadosDesincorporacionesBienesMuebles from "./Imprimir/ListadosDesincorporacionesBienesMuebles/ListadosDesincorporacionesMuebles";
import ListadosDesincorporacionesBienesInmuebles from "./Imprimir/ListadosDesincorporacionesBienesInmuebles/ListadosDesincorporacionesBienesInmuebles";
import InventarioBienesMuebles from "./Imprimir/InventarioBienesMuebles/InventarioBienesMuebles";
import ResumenInventarioBienesMuebles from "./Imprimir/ResumenInventarioBienesMuebles/ResumenInventarioBienesMuebles";
import MovimientosBienesMuebles from "./Imprimir/MovimientosBienesMuebles/MovimientosBienesMuebles";
import ResumenCuentasBienesMuebles from "./Imprimir/ResumenCuentasBienesMuebles/ResumenCuentasBienesMuebles";
import Usuarios from "./Configuracion/Usuarios/Usuarios";
import imgBienes from "../../imagenes/fd_bienes.png";
export default function BienesMunicipales() {
  const op = require("../../modulos/datos");

  const { user } = useContext(AuthContext);

  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const [show, setShow] = useState(false);
  const [tabla, setTabla] = useState(0);

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (obj != null) {
      setFechaSistema(obj.fechasistema);
    }
  }, []);

  useEffect(() => {
    if (tabla === 21) {
      console.log("Generando listado de transferencias de bienes...");
      setShow(false);
      setTabla(0);
    }
  }, [tabla]);

  const actualizacionItem = {
    title: "Actualización",
    icon: "fas fa-pen-alt me-2",
    drop: [
      {
        title: "Clasificador de Bienes",
        itemClickValue: 1,
        icon: "fa fa-edit me-2",
      },
      {
        title: "Catalogo de Activos",
        itemClickValue: 2,
        icon: "fa fa-folder me-2",
      },
      {
        title: "Ubicacion de Bienes",
        icon: "fa fa-map-marker-alt me-2",
        itemClickValue: 3,
      },
      {
        title: "Dispociciones ►",
        icon: "fa fa-folder me-2",
        subDrop: [
          {
            title: "Motivos de Incorporación",
            icon: "fa fa-plus me-2",
            itemClickValue: 4,
          },
          {
            title: "Motivos de Desincorporación",
            icon: "fa fa-minus me-2",
            itemClickValue: 5,
          },
        ],
      },
      {
        title: "Incorporacion de bienes ►",
        icon: "fa fa-building me-2",
        subDrop: [
          {
            title: "Incorporación de Bienes Muebles",
            icon: "fa fa-file me-2",
            itemClickValue: 6,
          },
          {
            title: "Incorporación de Bienes Inmuebles",
            icon: "fa fa-building me-2",
            itemClickValue: 7,
          },
        ],
      },
      {
        title: "Desincorporacion de Bienes ►",
        icon: "fa fa-building me-2",
        subDrop: [
          {
            title: "Desincorporación de Bienes Muebles",
            icon: "fa fa-file me-2",
            itemClickValue: 8,
          },
          {
            title: "Desincorporación de Bienes Inmuebles",
            icon: "fa fa-building me-2",
            itemClickValue: 9,
          },
        ],
      },
      {
        title: "Transferecia de Bienes",
        icon: "fa fa-exchange-alt me-2",
        itemClickValue: 10,
      },
    ],
  };
  const imprimirItem = {
    title: "Imprimir",
    icon: "fa fa-print me-2",
    drop: [
      {
        title: "Tipos de Activos",
        icon: "fa fa-search me-2",
        itemClickValue: 11,
      },
      {
        title: "Ubicaciones",
        icon: "fa fa-search me-2",
        itemClickValue: 12,
      },
      {
        title: "Listados Generales",
        icon: "fa fa-search me-2",
        subDrop: [
          {
            title: "Motivos de Incorporación",
            icon: "fa fa-plus me-2",
            itemClickValue: 13,
          },
          {
            title: "Motivos de Desincorporación",
            icon: "fa fa-minus me-2",
            itemClickValue: 14,
          },
          {
            title: "Listado Inventario Bienes Inmuebles",
            icon: "fa fa-building me-2",
            itemClickValue: 15,
          },
          {
            title: "Listado Iventario Bienes Muebles",
            icon: "fa fa-building me-2",
            itemClickValue: 16,
          },
        ],
      },
      {
        title: "Listados de Incorporaciones de Bienes ►",
        icon: "fa fa-search me-2",
        subDrop: [
          {
            title: "Bienes Muebles",
            icon: "fa fa-file me-2",
            itemClickValue: 17,
          },
          {
            title: "Bienes Inmuebles",
            icon: "fa fa-file me-2",
            itemClickValue: 18,
          },
        ],
      },
      {
        title: "Listados de Desincorporaciones de Bienes ►",
        icon: "fa fa-search me-2",
        subDrop: [
          {
            title: "Bienes Muebles",
            icon: "fa fa-file me-2",
            itemClickValue: 19,
          },
          {
            title: "Bienes Inmuebles",
            icon: "fa fa-file me-2",
            itemClickValue: 20,
          },
        ],
      },
      {
        title: "Listado de transferencias de Bienes",
        icon: "fa fa-search me-2",
        itemClickValue: 21,
      },
      {
        title: "Inventario de Bienes Muebles",
        icon: "fa fa-search me-2",
        itemClickValue: 22,
      },
      {
        title: "Resumen de Inventario de Bienes Muebles",
        icon: "fa fa-search me-2",
        itemClickValue: 23,
      },
      {
        title: "Movimientos de Bienes Muebles",
        icon: "fa fa-search me-2",
        itemClickValue: 24,
      },
      {
        title: "Resumen de las Cuentas de Bienes Muebles",
        icon: "fa fa-search me-2",
        itemClickValue: 25,
      },
    ],
  };
  const configuracionItem = {
    title: "Configuración",
    icon: "fa fa-cog me-2",
    drop: [
      {
        title: "Usuarios",
        icon: "fa fa-users me-2",
        itemClickValue: 26,
      },
    ],
  };

  const PorDefecto = () => {
    const azulProfundo = "#003a70";
    const azulVibrante = "#007bff";

    return (
      <section
        className="col-12 m-0 p-0"
        style={{ height: "90dvh", overflow: "hidden" }}
      >
        <style>{`
          @keyframes float {
            0% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
            50% { transform: translateY(-20px) translateX(10px); opacity: 1; }
            100% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
          }
          .tech-dot {
            position: absolute;
            background: white;
            border-radius: 50%;
            animation: float 6s infinite ease-in-out;
          }
        `}</style>

        <div
          className="col-md-12 row mx-auto px-0"
          style={{ minHeight: "100%" }}
        >
          <div
            className="col-md-6 d-flex justify-content-center align-items-center"
            style={{
              position: "relative",
              left: "-50px",
              borderBottomRightRadius: "30%",
              height: "90dvh",
              backgroundColor: azulProfundo,
              overflow: "hidden",
              boxShadow: "10px 0 30px rgba(0,0,0,0.2)",
            }}
          >
            {/* 1. FONDO MESH GRADIENT (Profundidad) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: `
                radial-gradient(circle at 20% 30%, ${azulVibrante} 0%, transparent 50%),
                radial-gradient(circle at 80% 70%, #00d4ff 0%, transparent 50%),
                ${azulProfundo}
              `,
              }}
            />

            {/* 2. REJILLA TECNOLÓGICA (Grid lines) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), 
                                linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
                backgroundSize: "50px 50px",
              }}
            />

            {/* 3. PUNTOS ANIMADOS (Partículas) */}
            <div
              className="tech-dot"
              style={{
                width: "6px",
                height: "6px",
                top: "20%",
                left: "15%",
                animationDelay: "0s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "4px",
                height: "4px",
                top: "60%",
                left: "25%",
                animationDelay: "1s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "8px",
                height: "8px",
                top: "40%",
                left: "80%",
                animationDelay: "2s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "3px",
                height: "3px",
                top: "80%",
                left: "60%",
                animationDelay: "1.5s",
              }}
            />

            {/* 4. RÁFAGAS DE LUZ DIAGONALES */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 20%, rgba(255,255,255,0.05) 50%, transparent 100%)",
                transform: "skewX(-20deg)",
              }}
            />

            {/* LOGO CON GLOW */}
            <div
              style={{ position: "relative", zIndex: 10, textAlign: "center" }}
            >
              <img
                style={{
                  filter: "drop-shadow(0px 0px 30px rgba(255,255,255,0.3))",
                  maxWidth: "100%",
                  transition: "transform 0.3s ease",
                }}
                className="img-fluid"
                src={imgBienes}
                alt="Logo SIAP"
              />
            </div>
          </div>

          {/* LADO DERECHO (Alcaldía) */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid px-5"
              src={op.imagenes + "/imagen?img=" + op.logohacienda}
              alt="Logo Alcaldía"
              style={{ maxWidth: "85%" }}
            />
          </div>
        </div>
      </section>
    );
  };
  const vista = {
    0: <PorDefecto />,
    1: <ClasificadorBienes setTabla={setTabla} setShow={setShow} show={show} />,
    2: <CatalogoActivos setTabla={setTabla} setShow={setShow} show={show} />,
    3: <UbicacionesBienes setTabla={setTabla} setShow={setShow} show={show} />,
    4: (
      <MotivosIncorporacion setTabla={setTabla} setShow={setShow} show={show} />
    ),
    5: (
      <MotivosDesincorporacion
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    6: (
      <IncorporacionBienesMuebles
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    7: (
      <IncorporacionBienesInmuebles
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    8: (
      <DesincorporacionBienesMuebles
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    9: (
      <DesincorporacionBienesInmuebles
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    10: (
      <TransferenciaBienes setTabla={setTabla} setShow={setShow} show={show} />
    ),
    17: (
      <ListadosIncorporacionesBienes
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    18: (
      <ListadosIncorporacionesBienesInmuebles
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    19: (
      <ListadosDesincorporacionesBienesMuebles
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    20: (
      <ListadosDesincorporacionesBienesInmuebles
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    22: (
      <InventarioBienesMuebles
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    23: (
      <ResumenInventarioBienesMuebles
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    24: (
      <MovimientosBienesMuebles
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    25: (
      <ResumenCuentasBienesMuebles
        setTabla={setTabla}
        setShow={setShow}
        show={show}
      />
    ),
    26: <Usuarios setTabla={setTabla} setShow={setShow} show={show} />,
  };

  if (!user) return <></>;

  return (
    <div className="w-100 col-12 m-0 p-0">
      <Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)}>
        <Item item={actualizacionItem} setTabla={setTabla} setShow={setShow} />
        <Item item={imprimirItem} setTabla={setTabla} setShow={setShow} />
        <Item item={configuracionItem} setTabla={setTabla} setShow={setShow} />
        <a
          href="/inicio"
          className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
        >
          <i className="fas fa-power-off me-2" />
          Salir
        </a>
      </Menu>
      <section
        className="w-100 col-12 m-0 p-0 d-flex align-items-center justify-content-center"
        style={{ height: "90dvh" }}
      >
        {vista[tabla]}
      </section>

      <Footer />
    </div>
  );
}
